import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const companyModURL = "api/v1/products-app/company";
//obtaining the paginated data
export const getCompany = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${companyModURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllCompany = () => axiosInstance.get(`${companyModURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageCompany = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${companyModURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

//creating function
export const createCompany = (body) => axiosInstance.post(`${companyModURL}/create`, body);
//updating function
export const updateCompany = (id, body) => axiosInstance.patch(`${companyModURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ search, rowsPerPage, sortOrder }) =>
  axiosInstance.get(`${companyModURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`);

// checking the redundant data
export const checkRedundantDataCompanyName = (e, cancelToken) =>
  axiosInstance.get(`${companyModURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
